export const locale = {
    lang: 'en',
    data: {
        'AUTH': {
            'TITLE': 'LOGIN TO YOUR ACCOUNT',
            'USERNAME': 'Username',
            'PASSWORD': 'Password',
            'LOGIN': 'LOG IN',
            'USERNAME_REQUIRED': 'Username is required',
            'PASSWORD_REQUIRED': 'Password is required'
        }
    }
};